import { render, staticRenderFns } from "./MoleculeTheAlerts.vue?vue&type=template&id=a5e488d0&"
import script from "./MoleculeTheAlerts.vue?vue&type=script&lang=js&"
export * from "./MoleculeTheAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports